// extracted by mini-css-extract-plugin
export var containerWithWebinars = "webinars-container-module--container-with-webinars--BEh5U";
export var webinarArrow = "webinars-container-module--webinar-arrow--FF5bu";
export var webinarContainer = "webinars-container-module--webinar-container--9vp2f";
export var webinarSubtitle = "webinars-container-module--webinar-subtitle--b61jG";
export var webinarText = "webinars-container-module--webinar-text--niWKW";
export var webinarTitle = "webinars-container-module--webinar-title--vdxN0";